import withContentCardTracking from '../../../decorators/containerItems/withContentCardTracking';

export const WithContentImpressionReporting = ({ trackingRef, children }) => (
  <div data-testid="guideItemWithContentImpressionReporting" ref={trackingRef}>
    {children}
  </div>
);

export default withContentCardTracking(WithContentImpressionReporting);
